export default __webpack_public_path__ + "static/media/tick.0c99e2b5.svg";